import * as moment from 'moment';

export class AircraftAdjustmentDto {
  componentName: string;
  serialNumber: string;
  componentId: number;
  aircraftProfileId: number;
  adjustmentType: string;
  adjustments: AircraftAdjustment[];

  constructor() {
    this.adjustments = [];
  }
}

export class AircraftAdjustmentSaveDto extends AircraftAdjustmentDto {
  deletes: number[];

  constructor() {
    super();
    this.deletes = [];
  }
}

export class AircraftAdjustment {
  adjustmentId: number;
  adjustmentDateTime: moment.Moment;
  createdByUser: string;
  createdDate: moment.Moment;
  cycles: number | null;
  durationMinutes: number | null;
  reason: string;
  componentType: string;
  action: string;
}
